import { Decimal } from "@liquity/lib-base"
import { Lexicon } from "../../lexicon"
import ExplorerIcon from "src/assets/images/explorer.svg"
import InfoIcon from "src/assets/images/info.svg"
import SwapIcon from "src/assets/images/swap.svg"
import { addressLink } from "src/utils/network"
import { twMerge } from "tailwind-merge"
import { capitalize } from "lodash"

type Props = {
  lexicon: Lexicon
  balance: Decimal
  usdPrice: Decimal
  tokenAddress: string
  chainId: number
  priceType: "oracle" | "market"
  className?: string
}

export const TokenInfo: React.FC<Props> = ({
  lexicon,
  balance,
  usdPrice,
  tokenAddress,
  chainId,
  priceType,
  className
}) => {
  return (
    <div className={twMerge("flex flex-col", className)}>
      <div className="flex flex-row items-center">
        <div className="flex flex-row items-center">
          <img src={lexicon.iconUrl} alt={lexicon.term} className="w-6 h-6"/>
          <div className="flex flex-col ml-2">
            <div className="flex flex-row items-baseline">
              <span className="text-style-attr leading-5">{balance.prettify()}</span>
              <span className="text-style-item ml-2 leading-3">{lexicon.term}</span>
            </div>
            <div className="text-style-sub leading-5">${balance.mul(usdPrice).prettify()}</div>
          </div>
        </div>
      </div>
      <div className="flex flex-row ml-8 items-baseline">
        <div className="text-style-label text-xs">{capitalize(priceType)} Price</div>
        <div className="text-style-sub ml-2">${usdPrice.prettify(2)}</div>
      </div>

      <div className="flex flex-row ml-8 mt-1">
        <a href={addressLink(chainId, tokenAddress)} target="_blank" rel="noreferrer">
          <img src={ExplorerIcon} alt="explorer" className="w-4 h-4"/>
        </a>
        <a href="/" target="_blank" rel="noreferrer" className="ml-2 pointer-events-none opacity-40">
          <img src={InfoIcon} alt="info" className="w-4 h-4"/>
        </a>
        <a href="/" target="_blank" rel="noreferrer" className="ml-2 pointer-events-none opacity-40">
          <img src={SwapIcon} alt="swap" className="w-4 h-4"/>
        </a>
      </div>
    </div>
  )

}